import request from "@assets/js/axios";
const {
  instance: $axios
} = request;
class Pay {
  constructor() {}
  // 支付结果
  payResult(OrderNO) {
    return $axios.get("/VisaOrder/getOrderPayStatus", {
      params: {
        OrderNO
      }
    });
  }
  payInfo({
    order_sn,
    type,
  }) {
    return $axios.get("/Yspay/request", {
      params: {
        payment_type: 'YspayAlipay',
        order_type: type,
        order_sn
      }
    })
  }

  // 获取支付宝支付二维码 2024-10-12 
  getAliPayCode(order_sn) {
    return $axios.get("/api/v2/Yspay/request", {
      params: {
        payment_type: 'YspayAlipay',
        order_type: 'xorder',
        order_sn: order_sn
      }
    });
  }
}

export default new Pay();